export default __webpack_public_path__ + "images/logo.svg?35d56001f631f256cac5758fa7655b6c";